import type { AssistantRole } from "@/types";

/**
 * Ask AI 의 지난 대화 — 화면을 열자마자 목록이 비어 보이지 않게 둘만 둔다.
 *
 * 금액(`cost_krw`)은 실제로 쓴 값이 아니라 보이기 위한 값이다. 목은 모델을 부르지 않는다
 * → ../handlers/assistant.ts
 */
export interface MockAssistantConversation {
  id: string;
  user_id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

export interface MockAssistantMessage {
  id: string;
  conversation_id: string;
  role: AssistantRole;
  content: string;
  model: string;
  /** 원. 질문은 0 이고 답에만 붙는다 */
  cost_krw: number;
  created_at: string;
}

export const assistantConversations: MockAssistantConversation[] = [
  {
    id: "conv-1",
    user_id: "u-owner",
    title: "건축법 시행령 개정 요약",
    created_at: "2026-10-20T10:12:00+09:00",
    updated_at: "2026-10-20T10:14:00+09:00",
  },
  {
    id: "conv-2",
    user_id: "u-owner",
    title: "회의록 다듬어 주세요",
    created_at: "2026-10-24T16:02:00+09:00",
    updated_at: "2026-10-24T16:03:00+09:00",
  },
];

export const assistantMessages: MockAssistantMessage[] = [
  {
    id: "msg-1",
    conversation_id: "conv-1",
    role: "user",
    content: "건축법 시행령 개정에서 설계 쪽에 영향 있는 것만 짚어 주세요.",
    model: "claude-sonnet-5",
    cost_krw: 0,
    created_at: "2026-10-20T10:12:00+09:00",
  },
  {
    id: "msg-2",
    conversation_id: "conv-1",
    role: "assistant",
    content:
      "목(mock) 응답이에요. 실제 모델을 부르지 않습니다.\n\n개정 내용은 관보나 법제처에서 확인해 주세요. 저는 사무소 데이터와 최신 법령을 보지 못합니다.",
    model: "claude-sonnet-5",
    cost_krw: 38,
    created_at: "2026-10-20T10:14:00+09:00",
  },
  {
    id: "msg-3",
    conversation_id: "conv-2",
    role: "user",
    content: "오늘 회의록 초안인데 문장 다듬어 주세요.",
    model: "claude-haiku-4-5-20251001",
    cost_krw: 0,
    created_at: "2026-10-24T16:02:00+09:00",
  },
  {
    id: "msg-4",
    conversation_id: "conv-2",
    role: "assistant",
    content: "목(mock) 응답이에요. 실제 모델을 부르지 않습니다.\n\n여기에 다듬은 글이 들어갑니다.",
    model: "claude-haiku-4-5-20251001",
    cost_krw: 12,
    created_at: "2026-10-24T16:03:00+09:00",
  },
];
